import { memo } from 'react';

import { type PublicBoardItemsViewProps } from '~/components/v2/components/board/PublicBoardContent';
import { PublicBoardTableView } from '~/components/v2/components/board/shared/table/PublicBoardTableView';
import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';

export type PublicShowcaseBoardTableViewProps = PublicBoardItemsViewProps;

/**
 * Table of a board drilled inside a showcase. The mixed list comes from the layout contract —
 * live `/a` ShortUrl, Edit + Preview workspace.
 */
export const PublicShowcaseBoardTableView = memo(({ scrollElementRef }: PublicShowcaseBoardTableViewProps) => {
  const { useBoardTableViewItems } = usePublicShowcaseContext();
  const itemsData = useBoardTableViewItems();

  return <PublicBoardTableView itemsData={itemsData} scrollElementRef={scrollElementRef} />;
});

PublicShowcaseBoardTableView.displayName = 'PublicShowcaseBoardTableView';
